import React, { useMemo } from 'react';

export const childrenToTextComponent = (children) => {
  if (typeof children === 'string') return <span>{children}</span>;
  return children;
};

/**
 * see: https://github.com/chakra-ui/chakra-ui/issues/6004#issuecomment-1133554188
 */
export const useChildrenAsText = (children) => useMemo(
  () => childrenToTextComponent(children),
  [children],
);
